import { capitalize, Typography } from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

export function Notes(): ReactElement {
    const { t } = useTranslation();

    return (
        <Typography
            sx={{ fontSize: 24, fontWeight: "bold", textTransform: "uppercase" }}
        >
            { capitalize(t("modules.reservations.dailyMessage.title")) }:
        </Typography>
    );
}